/** Paleta alinhada ao gradiente da logo Klinvia (ciano → azul). */
export const BRAND_COLORS = {
  cyan: '#22d3ee',
  light: '#38bdf8',
  main: '#3b82f6',
  dark: '#2563eb',
  deeper: '#1d4ed8',
  rgb: '59, 130, 246',
  cyanRgb: '34, 211, 238',
  bg: '#eff6ff',
} as const;

export const BRAND_GRADIENT = `linear-gradient(135deg, ${BRAND_COLORS.cyan} 0%, ${BRAND_COLORS.main} 100%)`;
export const BRAND_GRADIENT_HOVER = `linear-gradient(135deg, ${BRAND_COLORS.light} 0%, ${BRAND_COLORS.dark} 100%)`;
export const BRAND_GRADIENT_DEEP = `linear-gradient(135deg, ${BRAND_COLORS.dark} 0%, ${BRAND_COLORS.deeper} 100%)`;

export function brandRgba(alpha: number): string {
  return `rgba(${BRAND_COLORS.rgb}, ${alpha})`;
}

export function brandCyanRgba(alpha: number): string {
  return `rgba(${BRAND_COLORS.cyanRgb}, ${alpha})`;
}
